// ck-web sends credit_line values as Money strings (e.g. "50000.00").
const positiveAmount = (company, field) => {
  const amount = parseFloat(company?.credit_line?.get(field));
  return Number.isFinite(amount) && amount > 0 ? amount : null;
};

// The total credit line the company is approved for.
export const approvedCreditLineAmount = (company) =>
  positiveAmount(company, 'amount');

// What is left of the line after active and pending spend.
export const availableCreditAmount = (company) =>
  positiveAmount(company, 'remaining_amount');
